const user_module = {
  token:'/api/admin/oauth/token',//登录获取token
  refresh:'/api/admin/oauth/refresh',//获取refresh
  getUserInfo:'/api/admin/user/getUserInfo',//登录用户信息
  logout:'/api/auth/oauth/logout',//登录退出
  logoff:'/api/admin/oauth/logoff',//强制下线
  getUserPermission:'/api/admin/user/getUserPermission',//获取当前登录用户菜单权限
  getRoleSelect: "/api/admin/role/getRoleTree",//获取项目列表接口
}

export default user_module
